import React from "react";
import {
  KEIKA_OPTIONS,
  LAW_OPTIONS,
  YEAR_OPTIONS,
} from "./constants";

export default function ChiikiSearchForm({
  form,
  disabled,
  onFormChange,
  onSearch,
  onShowLawDialog,
  onShowKeikaDialog,
}) {
  return (
    <>
      <div className="lbl">情報を設定する</div>
      <div className="lbl">検索結果</div>
      <div className="input">
        <table>
          <tbody>
            <tr>
              <th>法区分</th>
              <td>
                <select
                  id="law"
                  value={form.law}
                  onChange={(e) => onFormChange("law", e.target.value)}
                >
                  {LAW_OPTIONS.map((option) => (
                    <option key={`${option.value}-${option.label}`} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <button type="button" className="mini-button" onClick={onShowLawDialog}>
                  詳細
                </button>
              </td>
            </tr>
            <tr>
              <th>経過措置</th>
              <td>
                <select
                  id="keikasochi"
                  value={form.keikasochi ? "1" : "0"}
                  onChange={(e) => onFormChange("keikasochi", e.target.value === "1")}
                >
                  {KEIKA_OPTIONS.map((option) => (
                    <option key={option.label} value={option.value ? "1" : "0"}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <button type="button" className="mini-button" onClick={onShowKeikaDialog}>
                  詳細
                </button>
              </td>
            </tr>
            <tr>
              <th>年度</th>
              <td>
                <select
                  id="date"
                  value={form.date}
                  onChange={(e) => onFormChange("date", e.target.value)}
                >
                  {YEAR_OPTIONS.map((option, idx) => (
                    <option key={`${option.value}-${idx}`} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>住所</th>
              <td>
                <input
                  id="addr"
                  type="text"
                  value={form.addr}
                  placeholder="入力してください"
                  onChange={(e) => onFormChange("addr", e.target.value)}
                />
                <span className="addr-example">例）北海道札幌市</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="request">
        <button type="button" onClick={onSearch} disabled={disabled}>
          地域区分を調べる
        </button>
      </div>
    </>
  );
}
